var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlaskIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9666 8.30382L8.65251 19.6189C8.40492 19.8665 8.11097 20.063 7.78745 20.197C7.46394 20.331 7.11718 20.4001 6.76699 20.4001C6.05975 20.4002 5.38144 20.1193 4.88129 19.6193C4.38113 19.1194 4.10009 18.4412 4.10001 17.734C4.09992 17.0268 4.38079 16.3486 4.88082 15.8484L16.195 4.53338M7.83302 12.9329H15.2999M15.2999 3.6001L20.9 9.19977M19.0333 14.7994L20.4333 16.2927C20.6709 16.5621 20.8258 16.8943 20.8792 17.2496C20.9327 17.6048 20.8825 17.9679 20.7347 18.2953C20.5869 18.6227 20.3477 18.9005 20.0459 19.0953C19.7441 19.2902 19.3925 19.3938 19.0333 19.3938C18.674 19.3938 18.3224 19.2902 18.0206 19.0953C17.7189 18.9005 17.4797 18.6227 17.3319 18.2953C17.1841 17.9679 17.1339 17.6048 17.1874 17.2496C17.2408 16.8943 17.3956 16.5621 17.6333 16.2927L19.0333 14.7994Z",
    stroke: "#322c36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlaskIcon);
export default __webpack_public_path__ + "static/media/flask-icon.0724ba1ddd27acae6558dfd331cc9854.svg";
export { ForwardRef as ReactComponent };